export default {
  name: 'XYDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    headerDivider: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('closed');
    }
  }
};